export default __webpack_public_path__ + "14166b5b34239ccd30fd8f20b96a53e0.svg";